export default {
  'meta': {
    'langName': 'SLOVAK',
    'lang': 'Slovenčina'
  },
  'title': 'STIAHNUTIE PODUKTU Z TRHU: ELEKTRICKÁ KOLOBEŽKA SD500E ALEBO MD500E BTWIN',
  'description': 'Dobrý deň,\n\nďakujeme, že ste si u nás zakúpili elektrickú kolobežku SD500E alebo MD500E značky BTWIN. \n\nVaša bezpečnosť je pre nás na prvom mieste, preto si, prosím, prečítajte nasledujúce informácie.\n\nAj napriek prísnym postupom kontroly kvality sme na elektrických kolobežkách SD500E a MD500E značky BTWIN zistili bezpečnostnú vadu. Pri intenzívnom používaní sa môže v mieste spoja medzi rámom a tyčou riadidiel objaviť prasklina. Tento nedostatok môže viesť k zlomeniu konštrukcie v tomto spoji, čo pre vás predstavuje riziko pádu.\n\nOdpovedzte nám, prosím, na niekoľko rýchlych otázok, aby sme pre váš produkt mohli zabezpečiť opravu pre bezpečnú jazdu.\n\nOspravedlňujeme sa za akékoľvek nepríjemnosti a ďakujeme za vašu dôveru.\n\nDECATHLON',
  'emailConfirmation': {
    'title': 'Najskôr, prosím, potvrďte svoju e-mailovú adresu a krajinu bydliska:'
  },
  'fields': {
    'country': 'Krajina',
    'address': 'E-mail',
    'email': 'E-mail',
    'phonePrefix': 'Predvoľba telefónneho čísla',
    'phone': 'Telefónne číslo',
    'validations': {
      'phoneOrEmail': 'Uveďte aspoň e-mailovú adresu alebo telefónne číslo.',
      'email': 'Zadajte, prosím, platný e-mail.',
      'phone': 'Zadajte, prosím, platné telefónne číslo.',
      'selectAddress': 'Vyberte, prosím, kompletnú adresu zo zoznamu (ulicu, číslo domu a mesto).',
      'incompleteAddress': 'Adresa musí obsahovať názov ulice, číslo domu a mesto. Napíšte aspoň ulicu a číslo, a potom kliknite na správny návrh.'
    },
    'firstName': 'Priezvisko',
    'lastName': 'Meno',
    'deliveryAddress': 'Doručovacia adresa balíka',
    'additionalAddress': 'Doplnkové údaje k adrese',
    'city': 'Mesto',
    'zip': 'PSČ',
    'readConfirmation': 'Potvrdzujem, že moje kontaktné údaje sú správne, prečítal(a) som si uvedené podmienky a súhlasím s nimi.',
    'choose': 'Vybrať',
    'required': 'Toto pole je povinné',
    'deliveryAddressHelp': 'Zadajte ulicu a číslo domu, a následne si zvoľte kompletnú adresu zo zoznamu.',
    'streetOnlyHint': 'Pridať číslo domu.'
  },
  'ownerCheck': {
    'title': 'Vlastníte stále jednu alebo viac elektrických kolobežiek BTWIN SD500E a MD500E?'
  },
  'yes': 'ÁNO',
  'no': 'NIE',
  'ownerChanged': {
    'title': 'Máte kontaktné údaje súčasného vlastníka (vlastníkov)?',
    'confirmation': 'Vážená pani/vážený pán,\n\nďakujeme Vám za účasť v tejto iniciatíve zameranej na kvalitu.\nOspravedlňujeme sa za spôsobené nepríjemnosti a ďakujeme Vám za Vašu dôveru.\n\nDECATHLON'
  },
  'recall': {
    'title': 'Zadajte, prosím, počet elektrických kolobežiek BTWIN SD500E a MD500E, ktoré vlastníte.',
    'descriptionSd500': 'Elektrické kolobežky SD500E',
    'descriptionEmd500e': 'Elektrické kolobežky MD500E',
    'modelNumberHelp': 'Číslo modelu (SD500E alebo MD500E) nájdete na spodnej strane kolobežky, presne tak, ako to vidíte na obrázku nižšie.',
    'quantity': 'Množstvo',
    'confirmation': 'Ďakujeme za vyplnenie formulára. Vašu požiadavku sme úspešne zaregistrovali.\n\nNajneskôr do 20 dní vás budeme informovať o presnom termíne, od ktorého môžete opravu vykonať.\n\nPrajeme vám pekný deň.\n\nDECATHLON'
  },
  'repair': {
    'title': 'Oprava, ktorú zvládnete sami',
    'description': 'Žiadame vás, aby ste kolobežku prestali používať.\n\nOpravnú sadu vám spolu s návodom pošleme priamo domov, aby ste si kolobežku mohli opraviť a ďalej ju bezpečne používať. Táto sada je, samozrejme, úplne zadarmo a jej montáž zvládnete rýchlo a jednoducho.\n\nPo spracovaní vašich údajov vás najneskôr do 20 dní budeme kontaktovať, aby sme vám potvrdili, kedy bude vaša opravná sada k dispozícii. Uisťujeme vás, že urobíme maximum pre to, aby sme túto čakaciu dobu čo najviac skrátili a zaistili vašu plnú spokojnosť.',
    'kitLabel': 'Kompletná opravná sada',
    'docLabel': 'Návod na opravu',
    'callToAction': 'Kliknite sem, aby ste získali opravnú sadu zadarmo',
    'infoConfirmation': 'Skontrolujte si, prosím, zadané údaje.',
    'validateConfirmation': 'Potvrdiť',
    'backConfirmation': 'Späť'
  },
  'repairRequest': {
    'title': 'Pre zaslanie opravnej sady zadajte, prosím, nasledujúce údaje:'
  },
  'form': {
    'submit': 'Ďalej'
  },
  'status': 'Translation validated by COUNTRY'
} as const
